const positiveInteger = (value) => {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

const legacyUrl = (values) => {
  const raw = values && values.next_page_url;
  if (typeof raw !== "string" || !raw) return null;

  try {
    return new URL(raw, "https://report-list.invalid");
  } catch (_error) {
    return null;
  }
};

export const reportLegacyQuery = (values, key) => legacyUrl(values)?.searchParams.get(key) || null;

export const reportPage = (values = {}) =>
  positiveInteger(values.page) || positiveInteger(reportLegacyQuery(values, "page"));

export const reportListLimit = (values = {}) =>
  positiveInteger(values.limit) || positiveInteger(reportLegacyQuery(values, "limit"));

// Paginator links from the old API may contain an absolute host. Keep only
// their pagination token and rebuild the request against the configured API.
export const localReportAction = (route, values = {}, query = "") => {
  const page = reportPage(values);
  const parts = [];
  if (page) parts.push(`page=${page}`);
  if (query) parts.push(query);
  return `${route}${parts.length ? `?${parts.join("&")}` : ""}`;
};
